module.exports = __webpack_public_path__ + "static/media/UNL-01.ca233292.png";